<template>
  <div class="NUOVOTICKET">
    <v-container fluid>
      <v-layout row wrap>
        <!-- <BreadCrumbs/> -->

        <v-flex d-flex xs12>
          <h4>COMPILAZIONE FOGLIO ORE</h4>
        </v-flex>
        <v-flex d-flex xs8>
          <h3>SETTIMANA DAL {{getDataStr(dateFrom)}} AL {{getDataStr(dateTo)}}</h3>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex d-flex xs2>
          <h3 @click="aggiornaDatiDaServer()">AGGIORNA</h3>
          <v-icon @click="aggiornaDatiDaServer()">refresh</v-icon>
        </v-flex>
        <v-flex d-flex xs5>
          <v-icon @click="settimanaPrecedente()">fast_rewind</v-icon>
          <v-icon @click="settimanaAttuale()">home</v-icon>
          <v-icon @click="settimanaSuccessiva()">fast_forward</v-icon>
        </v-flex>
        <v-flex d-flex xs12 lg2 sm12 md2 xl2>
          <v-btn @click="apriSchedaMese()">Visualizza scheda mese</v-btn>
        </v-flex>

        <v-dialog
          v-model="dialogSchedaMese"
          :fullscreen="$vuetify.breakpoint.smAndDown"
          :hide-overlay="$vuetify.breakpoint.smAndDown"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              <v-flex d-flex xs9 lg11>
              {{listaMesi[dateFrom.getMonth()]}} {{dateFrom.getFullYear()}}
              </v-flex>
              <v-flex xs3 lg1>
              <v-btn color="accent" justify-end @click="dialogSchedaMese = false">Chiudi</v-btn>
              </v-flex>
            </v-card-title>
            <v-data-table
              hide-actions
              disable-initial-sort
              :headers="headersSchedaMese"
              :items="schedaMese"
            >
              <template dense v-slot:items="props">
                <tr
                  v-bind:class="{red:props.item.giorno=='Dom',green: currentDate.getTime()== new Date(dateFrom.getFullYear(),dateFrom.getMonth(),props.item.num).getTime()}"
                  class="accent-1"
                >
                  <td class="text">{{ props.item.num }}</td>
                  <td class="text">{{ props.item.giorno }}</td>
                  <td class="text">{{ props.item.interne }}</td>
                  <td class="text">{{ props.item.esterne }}</td>
                  <td class="text">{{ props.item.viaggio }}</td>
                  <td class="text">{{ props.item.pernotto}}</td>
                </tr>
              </template>
            </v-data-table>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" @click="dialogSchedaMese = false">Chiudi</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--
 v-bind:pagination.sync="pagination" 
        -->

        <v-flex xs12>
          <v-data-table
            footer-props.items-per-page-text="Righe per pagina"
            :headers="headersProgetti"
            :items="progettiAttiviData"
            class="elevation-1 progettitable"
            hide-default-footer
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <b>COMMESSE / GIORNI</b>
                </th>
                <th v-for="header in props.headers" :key="header.text" :class="header.class">
                  <b>{{header.text}}</b>
                  <br />
                  {{getTotOreGiorno(header.keyData)}}
                  <v-text-field
                    :label="getTipoPermessoStr(header.keyData)"
                    @click="keyData=header.keyData, tipoPermesso=getTipoPermesso(header.keyData), apriDialogFerie(header.keyData)"
                  >{{getTipoPermesso(header.keyData)}}</v-text-field>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-xs-right">{{props.item.name}}</td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 0)"
                  :value="getValoreGiorno(props.item.c_project_id, 0)"
                  :readonly="true"
                  :class="getClassValue(0)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 1)"
                  :value="getValoreGiorno(props.item.c_project_id, 1)"
                  :readonly="true"
                  :class="getClassValue(1)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 2)"
                  :value="getValoreGiorno(props.item.c_project_id, 2)"
                  :readonly="true"
                  :class="getClassValue(2)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 3)"
                  :value="getValoreGiorno(props.item.c_project_id, 3)"
                  :readonly="true"
                  :class="getClassValue(3)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 4)"
                  :value="getValoreGiorno(props.item.c_project_id, 4)"
                  :readonly="true"
                  :class="getClassValue(4)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 5)"
                  :value="getValoreGiorno(props.item.c_project_id, 5)"
                  :readonly="true"
                  :class="getClassValue(5)"
                ></v-text-field>
              </td>
              <td class="text-xs-right">
                <v-text-field
                  v-on:click="dettaglioEvento(props.item.c_project_id, 6)"
                  :value="getValoreGiorno(props.item.c_project_id, 6)"
                  :readonly="true"
                  :class="getClassValue(6)"
                ></v-text-field>
              </td>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex d-flex xs12>
          <v-autocomplete
            :items="listaProgettiSelezionabili"
            item-text="selectdesc"
            item-value="c_project_id"
            label="Seleziona Commessa"
            v-model="progettoSelez"
            hide-no-data
            hide-selected
            placeholder="Scrivi per cercare"
            prepend-icon="mdi-database-search"
          ></v-autocomplete>

          <v-btn
            :disabled="isAggiuntaCommessaDisabled"
            color="blue"
            @click="aggiungiCommessaAlFoglioOre()"
          >Aggiungi</v-btn>
          <v-btn color="warning" @click="creaCommessa()">Crea</v-btn>
        </v-flex>
        <v-flex d-flex xs12>
          <label>Info: M->Manutenzione C->Commessa</label>
        </v-flex>


        <div class="text-xs-center">
          <!-- <v-btn color="primary" dark @click.stop="dialogDettaglioOre = true">Open Dialog</v-btn> -->
          <v-dialog
            v-model="dialogDettaglioOre"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :hide-overlay="$vuetify.breakpoint.smAndDown"
            persistent
            max-width="550px"
          >
            <v-card min-height="1%">
              <v-card-title>
                <v-flex>
                  <h3>REGISTRAZIONE ORE</h3>
                  <h5>{{getNomeProgetto(dialogProject_id)}}</h5>
                  <div>{{ card_text }}</div>
                </v-flex>
              </v-card-title>
            </v-card>

            <v-tabs
              v-model="tab"
              background-color="deep-purple accent-4"
              class="elevation-2"
              dark
              :centered="tabcentered"
              :prev-icon="tabprevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
              :next-icon="tabnextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
              :icons-and-text="tabicons"
            >
              <v-tab v-for="i in tabtabs" :key="i" :href="`#tab-${i}`">
                {{tabLabels[i-1]}}
                <v-icon v-if="tabicons">mdi-phone</v-icon>
              </v-tab>

              <v-tab-item v-for="i in tabtabs" :key="i" :value="'tab-' + i">
                <v-card>
                  <div v-if="i==1">
                    <v-flex d-flex xs12>
                      <v-flex d-flex xs12>
                        <v-text-field
                          label="Foglio di Lavoro "
                          maxlength="4"
                          @focus="$event.target.select()"
                          v-model="dialogFoglioDiLavoro"
                        ></v-text-field>
                      </v-flex>
                    </v-flex>
                    <v-card-text>
                      <b>ORE INTERNE</b>
                    </v-card-text>
                    <v-flex d-flex xs12>
                      <v-text-field
                        label="Ore interne"
                        :value="0"
                        @focus="$event.target.select()"
                        v-model="dialogOreInterne"
                        :rules="rules"
                      ></v-text-field>
                    </v-flex>
                    <v-card-text>
                      <b>ORE ESTERNE</b>
                    </v-card-text>
                    <v-flex d-flex xs12>
                      <v-text-field
                        label="Ore Montaggio"
                        :value="0"
                        @focus="$event.target.select()"
                        v-model="dialogOreEsterneMontaggio"
                        :rules="rules"
                      ></v-text-field>
                      <v-text-field
                        label="Ore Assistenza"
                        :value="0"
                        @focus="$event.target.select()"
                        v-model="dialogOreEsterneAssistenza"
                        :rules="rules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex d-flex xs12>
                      <v-text-field
                        label="Ore Viaggio"
                        :value="0"
                        :rules="rules"
                        @focus="$event.target.select()"
                        v-model="dialogOreViaggio"
                      ></v-text-field>
                    </v-flex>

                    <v-flex d-flex xs12>
                      <v-checkbox :label="`Pernotto`" v-model="dialogPernotto"></v-checkbox>

                      <v-select
                        v-if="dialogPernotto"
                        :items="listaTipoPernotto"
                        item-text="name"
                        item-value="value"
                        label="Seleziona Tipo Pernotto"
                        v-model="dialogTipoPernotto"
                      ></v-select>
                    </v-flex>
                  </div>
                  <!-- fine primo tab -->

                  <div v-if="i==2">
                    <h5>AGGIUNGI MATERIALE</h5>

                    <v-flex d-flex xs12>
                      <v-autocomplete
                        :items="listaProdotti"
                        item-text="pvaluedesc"
                        item-value="m_product_id"
                        label="Seleziona il materiale"
                        v-model="prodottoSelez"
                        hide-no-data
                        hide-selected
                        placeholder="Scrivi per cercare"
                        prepend-icon="mdi-database-search"
                        @change="handleProdottiChange"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex d-flex xs12>
                      <v-flex d-flex xs1></v-flex>

                      <v-flex d-flex xs11>
                        <v-text-field label="Descrizione prodotto" v-model="dialogDescProdotto"></v-text-field>
                      </v-flex>
                    </v-flex>

                    <v-flex d-flex xs12>
                      <v-flex d-flex xs1></v-flex>

                      <v-flex d-flex xs11>
                        <v-text-field
                          label="QTA"
                          :value="0"
                          :rules="rules"
                          @focus="$event.target.select()"
                          v-model="dialogQtaProdotto"
                        ></v-text-field>

                        <v-btn
                          color="green darken-1"
                          flat="flat"
                          @click="aggiungiProdotto()"
                        >Aggiungi</v-btn>

                        <v-btn
                          color="green darken-1"
                          flat="flat"
                          @click="cancellaProdotto()"
                        >Cancella</v-btn>
                      </v-flex>
                    </v-flex>

                    <h5>MATERIALE UTILIZZATO</h5>

                    <v-flex d-flex xs12>
                      <v-data-table
                        :headers="dtHeadersProdotti"
                        :items="dtProdotti"
                        class="elevation-1"
                      >
                        <template slot="items" scope="props">
                          <td class="text-xs">{{ props.item.prod }}</td>
                          <td class="text-xs">{{ props.item.desc }}</td>
                          <td class="text-xs">{{ props.item.qta }}</td>
                        </template>
                      </v-data-table>
                    </v-flex>

                    <v-flex d-flex xs12>{{dtProdotti}}</v-flex>
                  </div>

                  <div v-if="i==3">
                    <v-flex d-flex xs12>
                      <v-text-field label="Descrizione" v-model="dialogDescrizioneLavoro"></v-text-field>
                    </v-flex>

                    <v-flex d-flex xs12>
                      <v-text-field label="Note" v-model="dialogNoteLavoro"></v-text-field>
                    </v-flex>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs>

            <v-card min-height="1%">
              <v-card-actions>
                <!--
                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogDettaglioOre = false"
                >Annulla</v-btn>-->

                <v-icon
                  :disabled="dialogFct_timesheetwh_ID ?  false : true"
                  @click="dialogConfermiCancellazione = true"
                >delete_forever</v-icon>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogDettaglioOre = false"
                >Annulla</v-btn>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogDettaglioOre = false, salvaRegistrazioneOre()"
                >Salva</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div class="text-xs-center">
          <!-- <v-btn color="primary" dark @click.stop="dialogDettaglioOre = true">Open Dialog</v-btn> -->
          <v-dialog
            v-model="dialogNuovaCommessa"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :hide-overlay="$vuetify.breakpoint.smAndDown"
            persistent
            max-width="450px"
          >
            <v-card>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">NUOVA COMMESSA</h3>
                  <div>{{ card_text }}</div>
                </div>

                <v-card-text>
                  <b>CLIENTE</b>
                  <v-autocomplete
                    :items="listaBPartner"
                    item-text="bpname"
                    item-value="c_bpartner_id"
                    label="Seleziona Cliente"
                    v-model="dialogCommCBPartnerID"
                    hide-no-data
                    hide-selected
                    placeholder="Scrivi per cercare"
                    prepend-icon="mdi-database-search"
                  ></v-autocomplete>
                </v-card-text>
                <v-card-text>
                  <b>Numero Foglio Ore</b>
                </v-card-text>
                <v-flex d-flex xs12>
                  <v-text-field
                    label="Numero Foglio Ore"
                    :value="0"
                    v-model="dialogCommDescrizione"
                  ></v-text-field>
                </v-flex>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogNuovaCommessa = false"
                >Annulla</v-btn>

                <v-btn
                  :disabled="isNuovaCommessaDisabled"
                  color="green darken-1"
                  flat="flat"
                  @click="dialogNuovaCommessa = false, salvaCommessaSuServer()"
                >Salva</v-btn>
                <!-- salvaFerieSuServer(dataStrUni, tipoPermesso -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <!-- DIALOG FERIE ETC... -->
        <!--  -->
        <v-dialog
          v-model="dialogCambiaTipoPermesso"
          :fullscreen="$vuetify.breakpoint.smAndDown"
          :hide-overlay="$vuetify.breakpoint.smAndDown"
          max-width="350px"
        >
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">TIPO DI PERMESSO</h3>
              </div>
            </v-card-title>

            <v-select
              :items="listaTipoPermesso"
              item-text="name"
              item-value="value"
              label
              v-model="tipoPermesso"
            ></v-select>
            <v-card-title primary-title></v-card-title>

            <v-card-actions>
              Data: {{dialogCambiaTipoPermessoData}}
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                @click="dialogCambiaTipoPermesso = false, salvaFerieSuServer(dialogCambiaTipoPermessoData , tipoPermesso)"
              >SALVA</v-btn>
              <!-- salvaFerieSuServer(dataStrUni, tipoPermesso -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="text-xs-center">
          <!-- <v-btn color="primary" dark @click.stop="dialogDettaglioOre = true">Open Dialog</v-btn> -->
          <v-dialog
            v-model="dialogConfermiCancellazione"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            :hide-overlay="$vuetify.breakpoint.smAndDown"
            max-width="450px"
          >
            <v-card>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">Elimino la registrazione ore ?</h3>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogConfermiCancellazione = false"
                >NO</v-btn>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="dialogConfermiCancellazione = false, cancellaRegistrazioneOre()"
                >SI</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-layout>
    </v-container>

    <!--
    <DialogOperationRunning
      :dialogTitle="operationRunningTitle"
      :dialogMessage="progressMessage"
      :dialog.sync="progressMessageEnable"
      v-bind:isactive="progressMessageEnable"
    />-->
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vuetify/dist/vuetify.js"></script>

<script>
import EventoOre from "../regOre.js";
export default {
  //mixins: [mixinCommon],
  data() {
    return {
      //TAB nuova commessa definition
      tab: null,
      tabtext:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      tabicons: false,
      tabcentered: true,
      tabgrow: false,
      tabvertical: false,
      tabprevIcon: false,
      tabnextIcon: false,
      tabright: false,
      tabtabs: 1,
      tabLabels: ["ORE", "MATERIALI", "NOTE"],

      //Permesso/ferie/malattia
      listaPermessi: [], //array di permessi con {key, value} dove key è la data e value può essere L, F, PR o M
      dialogCambiaTipoPermesso: false,
      dialogCambiaTipoPermessoData: null,
      listaTipoPermesso: [
        { name: "Lavorativo", value: "L" },
        { name: "Ferie", value: "F" },
        { name: "Permesso", value: "PR" },
        { name: "Malattia", value: "M" }
      ],
      tipoPermesso: "L", //model usato nella dialog
      keyData: "", //model della key usato nella dialog
      //
      //Modalità pernotto
      listaTipoPernotto: [
        { name: "Italia", value: "I" },
        { name: "Europa", value: "E" },
        { name: "Mondo", value: "M" }
      ],
      dialogTipoPernotto: "I",
      //
      //
      card_text: null,
      //dialogDettaglioOre
      dialogConfermiCancellazione: false,

      //DialogCommessa
      dialogNuovaCommessa: false,
      //
      dialogCommDescrizione: "",
      dialogCommCBPartnerID: null,
      cBPartnerIDSelez: null,
      //
      //Dati dialog model
      dialogDettaglioOre: false,
      //
      dialogFoglioDiLavoro: "",
      dialogOreInterne: 0,
      dialogOreEsterneMontaggio: 0,
      dialogOreEsterneAssistenza: 0,
      dialogOreViaggio: 0,
      dialogPernotto: true,
      dialogProject_id: null,
      dialogDaynum: null,
      dialogFct_timesheetwh_ID: null,
      dialogSchedaMese: false,

      //TAB MATERIALI
      listaProdotti: [],
      prodottoSelez: null,
      dialogDescProdotto: null,
      dialogQtaProdotto: null,
      dtHeadersProdotti: [
        { text: "Prodotto", value: "prod" },
        { text: "Descrizione", value: "desc" },
        { text: "Qta", value: "qta" }
        //{ text: 'Elimina', value: 'elimina' },
      ],
      dtProdotti: [
        {
          m_product_id: "123",
          prod: "Mandrino",
          desc: "Mandrino123",
          qta: 6.0
        },
        {
          m_product_id: "456",
          prod: "",
          desc: "Cinghia 456",
          qta: 2.0
        }
      ],

      //TAB NOTE
      dialogDescrizioneLavoro: "",
      dialogNoteLavoro: "",

      rules: [
        v => {
          var stringa = v;
          var oraMinuti = stringa.split(".");
          if (oraMinuti.length == 2) {
            console.log(oraMinuti);
            var risultato = parseInt(oraMinuti[1] % 15);
            console.log(risultato);
            if (risultato != 0) {
              return "I minuti devono essere multipli di 15";
            } else {
              return true;
            }
          } else {
            return false;
          }
          return "Error";
        }
      ],

      //dataFrom: "10/05/2019",
      //dataTo: "20/05/2019",
      /*
      headersProgetti: [
        {
          text: "COMMESSA",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "10/05/2019",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "11/05/2019",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "12/05/2019",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "13/05/2019",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],*/
      //progetti attivi nei quali ci sono attività
      progettiAttiviData: [
        {
          /*c_project_id: "123",
          name: "PRJ1"*/
        }
      ],
      //array con tutte le ore presenti nell'intervallo di date specificate
      /*
      Interne: 0,
      dialogOreEsterneMontaggio: 0,
      dialogOreEsterneAssistenza: 0,
      dialogOreViaggio: 0,
      dialogPernotto

                  oreInterne: "0",
            oreEsterneMontaggio: "1",
            oreEsterneAssistenza: "0",
            OreViaggio: "0.5",
            pernotto: true
          }

      */
      dataOre: [
        /*
        {
          c_project_id: "123",
          data: "2019-04-03",
          ore: "1.5",
          name: "PRJ1",
          eventoOre: null
        },
        {
          c_project_id: "123",
          data: "2019-05-15",
          ore: "1",
          name: "PRJ1",
          eventoOre: null
        },
        {
          c_project_id: "123",
          data: "2019-04-03",
          ore: "1.5",
          name: "PRJ1",
          eventoOre: null
        }*/
      ],
      //array di progetti che sono in fase di inserimento ma non hanno ancora dati
      //progettiInInserimento: [
      //{ c_project_id: "123", data: "2019-04-03", ore: "1.5", name: "PRJ1" },
      //],
      //lista di tutti i progetti disponibili
      listaProgetti: [
        /*{ name: "PRJ1", c_project_id: "123" },
        { name: "PRJ2", c_project_id: "128" }*/
      ],
      listaProgettiSelezionabili: [],
      listaBPartner: [
        /*{ name: "PRJ1", c_project_id: "123" },
        { name: "PRJ2", c_project_id: "128" }*/
      ],
      progettoSelez: null,
      dataRifSettimanaSelezionata: null,
      dataRifS: null,
      //settimanaSelezionata: null,
      rules: [
        v => {
          //console.log(`Rule called for ${v}`);
          var stringa = v;
          if (typeof stringa == "string") {
            var oraMinuti = stringa.split(".");
            //if (oraMinuti.length != 2) {
            //  return "Deve essere nel formato 2.20";
            //} else {
            if (oraMinuti.length == 2) {
              //console.log(oraMinuti);
              var risultato = parseInt(oraMinuti[1] % 15);
              //console.log(risultato);
              if (risultato != 0) {
                return "I minuti devono essere multipli di 15";
              } else {
                return true;
              }
            }
            if (oraMinuti.length == 1) {
              return true;
            }
            return "Error";
          }
          return true;
        }
      ],
      listaMesi: [
        "",
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre"
      ],
      headersSchedaMese: [
        { text: "N", width: "1%", sortable: false },
        { text: "Giorno", width: "1%", sortable: false },
        { text: "Interne", width: "1%", sortable: false },
        { text: "Esterne", width: "1%", sortable: false },
        { text: "Viaggio", width: "1%", sortable: false },
        { text: "Pernotto", width: "1%", sortable: false }
      ],
      schedaMese: [],
      giorniSettimana: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"]
    };
  },
  methods: {
    handleProdottiChange(e) {
      var that = this;
      console.log(e);
      this.listaProdotti.forEach(function(item, index) {
        if (parseInt(item.m_product_id) == parseInt(that.prodottoSelez)) {
          that.dialogDescProdotto = item.pname;
          console.log(item.pname);
        }
      });
    },
    aggiungiProdotto() {
      //dev nuovo prodotto
      var nuovoProdotto = {};

      nuovoProdotto.m_product_id = this.prodottoSelez;
      nuovoProdotto.prod = this.dialogDescProdotto;
      nuovoProdotto.desc = this.dialogDescProdotto;
      nuovoProdotto.qta = this.dialogQtaProdotto;

      this.dtProdotti.push(nuovoProdotto);
    },
    cancellaProdotto() {
      //cancella la riga del prodotto dalla tabella sottostante
    },
    getTotOreGiorno(keyData) {
      //console.log(keyData);
      //return "ciaopippo";
      var totMinuti = 0;
      this.dataOre.forEach(function(item, index) {
        if (item.data === keyData) {
          totMinuti += item.eventoOre.totaleMinuti();
        }
      });
      return this.daMinutiAOre(totMinuti).toFixed(2);
    },
    daMinutiAOre(minutiT) {
      if (minutiT > 0) {
        var ore = Math.floor(minutiT / 60);
        //console.log(minutiT + "ore" + ore)
        var minuti = (minutiT - ore * 60) / 100;
        //console.log(minutiT + "minuti" + minuti)
        return ore + minuti;
      } else {
        return 0;
      }
    },
    cancellaRegistrazioneOre() {
      console.log("cancellaRegistrazioneOre");
      this.cancellaRegistrazioneOreServer();
      this.dialogDettaglioOre = false;
      this.dialogFoglioDiLavoro = null;
    },
    //salvaRegistrazioneOre
    defaultValueZero(ore) {
      if (ore == "" || ore == null) {
        return 0;
      } else {
        return ore;
      }
    },
    salvaRegistrazioneOre() {
      //console.log("salvaRegistrazioneOre");
      //console.log(this.dialogOreViaggio);
      //alert(this.dialogOreViaggio);
      var eO = new EventoOre(
        this.dialogProject_id,
        this.defaultValueZero(this.dialogOreInterne),
        this.defaultValueZero(this.dialogOreEsterneMontaggio),
        this.defaultValueZero(this.dialogOreEsterneAssistenza),
        this.defaultValueZero(this.dialogOreViaggio),
        this.dialogPernotto ? "Y" : "N",
        this.dialogTipoPernotto,
        this.dialogFoglioDiLavoro,
        this.dialogFct_timesheetwh_ID
      );

      this.setValoreGiorno(this.dialogProject_id, this.dialogDaynum, eO);
      this.dialogFoglioDiLavoro = null;
    },
    dettaglioEvento(project_id, daynum) {
      //TODO
      //if malattia disabilitare

      //props.item.c_project_id, 0
      //chiamato quando si clicca su una cella apre una finestra modale
      console.log("dettaglioEvento daynum " + daynum);
      this.dialogProject_id = project_id;
      this.dialogDaynum = daynum;

      var eventoGiorno = this.getEventoGiorno(project_id, daynum);
      //console.log(eventoGiorno);
      if (eventoGiorno != null) {
        //console.log("diverso da null");
        //console.log("eventoGiorno.pernotto" + eventoGiorno.pernotto);
        console.log(eventoGiorno);
        this.dialogOreInterne = eventoGiorno.oreInterne;
        this.dialogOreEsterneMontaggio = eventoGiorno.oreEsterneMontaggio;
        this.dialogOreEsterneAssistenza = eventoGiorno.oreEsterneAssistenza;
        this.dialogOreViaggio = eventoGiorno.oreViaggio;
        this.dialogPernotto = eventoGiorno.pernotto == "Y" ? true : false;
        this.dialogTipoPernotto = eventoGiorno.tipoPernotto;
        this.dialogFoglioDiLavoro = eventoGiorno.fogliodilavoro;
        this.dialogFct_timesheetwh_ID = eventoGiorno.fct_timesheetwh_id;
      } else {
        //console.log(" null");
        this.dialogOreInterne = 0;
        this.dialogOreEsterneMontaggio = 0;
        this.dialogOreEsterneAssistenza = 0;
        this.dialogOreViaggio = 0;
        this.dialogPernotto = false;
        this.dialogTipoPernotto = "I";
        //this.dialogFoglioDiLavoro = null;
        this.dialogFct_timesheetwh_ID = null;
      }

      this.dialogDettaglioOre = true;
    },
    creaCommessa() {
      // Crea una nuova commessa su idempiere (come manutenzione ??) e
      // e la aggiunge alla tabella
      this.dialogNuovaCommessa = true;

      //console.log("Creazione nuova commessa su Idempiere");
      // alert("Da implementare - non funzionante");
    },
    getNomeProgetto(c_project_id) {
      //console.log(c_project_id);
      var nome = "-";
      if (c_project_id) {
        //console.log(this.progettiAttiviData);
        this.progettiAttiviData.forEach(function(item, index) {
          //console.log(item.c_project_id);
          if (parseInt(item.c_project_id) == parseInt(c_project_id)) {
            //console.log(item);
            //console.log("Trovato " + item.name);
            nome = item.name;
          }
        });
      } else {
        nome = "-";
      }
      return nome;
    },
    getTipoPermesso(keyData) {
      //return "pippo >" + keyData
      var str = "L";
      this.listaPermessi.forEach(function(permesso) {
        //console.log(permesso)
        if (permesso.key == keyData) {
          str = permesso.value;
        }
      });
      return str;
    },
    getTipoPermessoStr(keyData) {
      //console.log("getTipoPermessoStr >" + keyData)
      var key = this.getTipoPermesso(keyData);
      var str = "";

      this.listaTipoPermesso.forEach(function(permessoTipo) {
        if (permessoTipo.value == key) {
          str = permessoTipo.name;
        }
      });
      return str;
    },
    //chiamato dalla dialog
    /*
    confermaTipoPermesso() {
      //console.log("tipo evento")
      this.listaPermessi.push({ key: this.keyData, value: this.tipoPermesso });
      //this.$forceUpdate();
      console.log(this.listaPermessi);
    },
    */
    getClassValue(numGiorno) {
      var strClass = "";
      //dataRifSettimanaSelezionata;
      var d = new Date(this.dataRifSettimanaSelezionata);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) + numGiorno;

      var dataColonna = new Date(d.setDate(diff));
      var dataStrUni = this.getDataStrUNI(dataColonna);
      //console.log("dataStrUni" + dataStrUni + "" + this.getTipoPermesso(dataStrUni))
      if (this.getTipoPermesso(dataStrUni) == "PR") {
        strClass = "permessoclass";
      } else if (this.getTipoPermesso(dataStrUni) == "F") {
        strClass = "ferieclass";
      } else if (this.getTipoPermesso(dataStrUni) == "M") {
        strClass = "malattiaclass";
      }
      return strClass;
    },
    //fine metodi riguardanti FERIE PERMESSI ETC....
    getListaProgetti() {
      // scorre progettiAttiviData
      // progettiAttiviData: [{ data: "02/04/2019", ore: 2, c_project_id: "123", nameProgetto:"" }],
      // e trova tutti gli idprogetto univoci
      var progettiAttiviData = [];

      //for (var registrazione in this.progettiAttiviData) {
      this.dataOre.forEach(function(item, index) {
        var valorePresente = false;
        progettiAttiviData.forEach(function(item1, index1) {
          if (item.c_project_id == item1.c_project_id) {
            valorePresente = true;
          }
        });

        if (!valorePresente) {
          var newItem = {};
          newItem.c_project_id = item.c_project_id;
          newItem.name = item.name;

          progettiAttiviData.push(newItem);
        }
      });
      //console.log(progettiAttiviData);
      this.progettiAttiviData = progettiAttiviData;
      //console.log(progettiAttiviData);
    },
    setValoreGiorno(c_project_id, numGiorno, eventoOre) {
      // salva su array dataOre
      // l'evento facendo un update oppure un insert

      var d = new Date(this.dataRifSettimanaSelezionata);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) + numGiorno;

      var dataColonna = new Date(d.setDate(diff));
      var dataStrUni = this.getDataStrUNI(dataColonna);
      var valoreRitorno = 0;
      var trovatoSuOreGiorno = false;

      this.dataOre.forEach(function(item, index) {
        //console.log(item.data);
        //console.log(dataStrUni);
        //if (item.data == dataStrUni) {
        //  console.log("TROVATO !!!!");
        //}
        if (
          valoreRitorno == 0 &&
          item.c_project_id == c_project_id &&
          item.data == dataStrUni
        ) {
          //console.log("TROVATO !!!!" + numGiorno);
          //console.log(item.ore);
          //valoreRitorno = item.ore;
          // && item.data == dataStrUni) {
          //console.log(eventoOre.totaleOre());
          item.ore = eventoOre.totaleOre();
          item.eventoOre = eventoOre;
          trovatoSuOreGiorno = true;
        } /* else {
          valoreRitorno = 0;
        }*/
      });
      //console.log("trovatoSuOreGiorno" + trovatoSuOreGiorno);
      if (!trovatoSuOreGiorno) {
        // se non trovato lo creo
        this.dataOre.push({
          c_project_id: c_project_id,
          data: dataStrUni,
          //name: "PRJ1",
          ore: eventoOre.totaleOre(),
          eventoOre: eventoOre
        });
        //console.log(this.dataOre);
      }
      this.salvaEventoSuServer(eventoOre, dataStrUni);
      // aggiungo un nuovo evento
    },
    getValoreGiorno(c_project_id, numGiorno) {
      //return "1223"

      var evento = this.getEventoGiorno(c_project_id, numGiorno);
      if (evento == null) {
        //var oreTest = new EventoOre(123, 11, 1, 3, 3, false, "I", "21", -1);
        return "-";
      } else {
        return evento.rappStr();
      }
      //return oreTest;

      //evento.rappStr()return evento == null ? 0 : evento.rappStr();
    },
    getEventoGiorno(c_project_id, numGiorno) {
      //return numGiorno;

      //var oreTest = new EventoOre(123, 11, 1, 3, 3, false, "I", "21", -1);
      //return oreTest;

      //dataOre: [
      //  { c_project_id: "123", data: "2019-04-03", ore: "1.5", name: "PRJ1" },
      // bisogna prendere la data dalla dataRifSettimanaSelezionata
      // partire dal lunedì
      // e aggiungere il numero di giorni numGiorno passato come parametro
      //
      // a questo punto bisogna scorrere l'array dataOre, cercare l'elemento e tornare il valore
      //
      //

      var d = new Date(this.dataRifSettimanaSelezionata);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) + numGiorno;

      var dataColonna = new Date(d.setDate(diff));
      var dataStrUni = this.getDataStrUNI(dataColonna);
      var valoreRitorno = null;

      /*console.log(
        "Cerco gli eventi corrispondenti al giorno " +
          dataStrUni +
          "projec " +
          c_project_id
      );
*/
      //var oreTest = new EventoOre(123, 11, 1, 3, 3, false, "I", "21", -1);
      //return oreTest;

      this.dataOre.forEach(function(item, index) {
        //console.log("#" + item.data + "#" + dataStrUni + "#");

        if (
          valoreRitorno == null &&
          item.c_project_id == c_project_id &&
          item.data === dataStrUni
        ) {
          //console.log("TROVATO !!!!");
          //console.log("#" + item.data + "#" + dataStrUni + "#");
          //console.log("#" + item.c_project_id + "#" + c_project_id + "#");
          //item.eventoOre.desc = item.data; //DEBUG
          valoreRitorno = item.eventoOre;
        }

        /*
        if (
          valoreRitorno == null &&
          item.c_project_id == c_project_id //&&
          //item.data === dataStrUni
        ) {
          //console.log("TROVATO !!!!");
          //console.log(item.ore);
          //var oreTest = new EventoOre(123, 12, 2, 5, 3, false, "I", "21", -1);
          //valoreRitorno = oreTest;

          item.eventoOre.desc = item.data;
          valoreRitorno = item.eventoOre;

          //// && item.data == dataStrUni) {
        }
        
        */

        /* else {
          var oreTest = new EventoOre(123, 20, 20, 10, 3, false, "I", "21", -1);
          valoreRitorno = oreTest;
        }*/
      });
      //console.log("fine getValoreGiorno" + valoreRitorno);
      //var oreTest = new EventoOre(123, 12, 2, 5, 3, false, "I", "21", -1);
      //return oreTest
      return valoreRitorno;
    },
    getSettimanaCorrente(datep) {
      var date = new Date(datep);
      date.setHours(0, 0, 0, 0);
      // Thursday in current week decides the year.
      date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
      // January 4 is always in week 1.
      var week1 = new Date(date.getFullYear(), 0, 4);
      // Adjust to Thursday in week 1 and count number of weeks from date to week1.
      return {
        sett:
          1 +
          Math.round(
            ((date.getTime() - week1.getTime()) / 86400000 -
              3 +
              ((week1.getDay() + 6) % 7)) /
              7
          ),
        year: date.getFullYear()
      };
    },
    aggiornaDateFromTo() {
      function getDateOfWeek(w, y) {
        var d = 1 + (w - 1) * 7; // 1st of January + 7 days for each week
        return new Date(y, 0, d);
      }
    },
    settimanaPrecedente() {
      //console.log("settimanaPrecedente");
      var result = new Date(this.dataRifSettimanaSelezionata);
      //console.log(result);
      result.setDate(result.getDate() - 7);
      //console.log(result);
      this.dataRifSettimanaSelezionata = result;
      this.getListaListaOreServer();
    },
    settimanaSuccessiva() {
      //console.log("settimanaSuccessiva");
      var result = new Date(this.dataRifSettimanaSelezionata);
      result.setDate(result.getDate() + 7);
      this.dataRifSettimanaSelezionata = result;
      this.getListaListaOreServer();
    },
    settimanaAttuale() {
      this.dataRifSettimanaSelezionata = new Date();
      this.getListaListaOreServer();
    },
    getDataStrUNI(sd) {
      //console.log(sd + "aaa");
      //var d = new Date(sd.replace(' ', 'T'));

      var d = new Date(sd);

      var month = String(d.getMonth() + 1);
      var day = String(d.getDate());
      var year = String(d.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return year + "-" + month + "-" + day;

    },
    getDataStr(sd) {
      //console.log(sd);

      var d = new Date(sd);

      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${day}/${month}/${year}`;
    },
    //una volta selezionata la commessa la aggiungo alla tabella
    aggiungiCommessaAlFoglioOre() {
      //console.log("aggiungiCommessa >>> " + this.progettoSelez);
      var that = this;
      if (this.progettoSelez) {
        //controllo se selezionata
        var c_project_id_daaggiungere = this.progettoSelez;

        var trovatoDup = false;
        this.dataOre.forEach(function(item, index) {
          if (
            item.c_project_id == c_project_id_daaggiungere &&
            trovatoDup == false
          ) {
            alert("Commessa/Manutenzione già presente");
            trovatoDup = true;
          }
        });

        this.listaProgettiSelezionabili.forEach(function(item, index) {
          if (item.c_project_id == c_project_id_daaggiungere) {
            var newItem = {};
            //{ c_project_id: "123", data: "2019-04-03", ore: "1.5", name: "PRJ1" }
            newItem.c_project_id = item.c_project_id;
            newItem.name = item.selectdesc;
            that.dataOre.push(newItem);
          }
        });
      }
      this.getListaProgetti();
    },
    //richede al server i dati
    aggiornaDatiDaServer() {
      this.getListaFerieMalattie();

      this.getListaListaOreServer();
      this.getListaBPartnerServer();
      this.getListaCommesseServer();
    },
    //Chiamato dalla
    salvaCommessaSuServer() {
      console.log("salvaCommessaSuServer");

      //modifica per fare in modo che al posto di una commessa venga aggiunto un foglio di lavoro
      this.dialogFoglioDiLavoro = this.dialogCommDescrizione;

      var data = {};
      data.Name = "Foglio di Lavoro " + this.dialogCommDescrizione;
      data.C_BPartner_ID = this.dialogCommCBPartnerID;
      data.C_Currency_ID = 102;
      data.C_Activity_ID = 1000003;
      data.fct_commessastatus_ID = 1000004;

      var datadef = {};
      datadef.Name = "s";
      datadef.C_BPartner_ID = "i";
      datadef.C_Currency_ID = "i";
      datadef.C_Activity_ID = "i";
      datadef.fct_commessastatus_ID = "i";

      var parameters = {};
      parameters.webServiceName = "CreateCommessa";
      parameters.data = data;
      parameters.datadef = datadef;

      parameters.urlMethod = "/idempiere/callWebService";
      parameters.debug = true;

      //console.log(parameters);

      this.$store.dispatch("postAxiosAction", parameters).then(
        response => {
          console.log(response);
          console.log(response[0]);
          console.log(response[0].recordID);

          var newItem = {};
          //{ c_project_id: "123", data: "2019-04-03", ore: "1.5", name: "PRJ1" }
          newItem.c_project_id = response[0].recordID;
          newItem.name = data.Name;
          this.dataOre.push(newItem);

          this.getListaProgetti();
          
        },
        error => {
          console.error("Niente dal server riprovo nuovamente");
        }
      );
    },
    apriDialogFerie(keyData) {
      this.dialogCambiaTipoPermessoData = keyData;

      //per aprire la dialog
      this.dialogCambiaTipoPermesso = true;
    },
    async salvaFerieSuServer(dataStrUni, tipoPermesso) {
      var that = this;
      /*
       * Chiamato dalla dialog della selezione in alto sul giorno
       * Salva lo stato di Ferie/Permesso/Malattia/Lavoro di un certo giorno
       *
       * Prima verifico se sul server è già salvato il record per questo utente
       * per capire se fare un INSERT o un UPDATE
       *
       */

      //console.log("tipo evento")
      this.listaPermessi.push({ key: this.keyData, value: this.tipoPermesso });

      var data = {};
      data.AD_User_ID = this.$session.get("ad_user_id");
      data.day = dataStrUni + " 00:00:00";
      data.Type = tipoPermesso;

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.day = "s";
      datadef.Type = "s";

      //carica dettaglio item attivo
      var parameters = {};
      parameters.day = dataStrUni + " 00:00:00"

      parameters.urlMethod = "webservices/rest/v1/vitech/getHoliday";
      parameters.debug = true;

      var verificaStatoGiorno
      await this.$store.dispatch("callGenericPostMethod", parameters).then(response => {
        verificaStatoGiorno = response
        console.log("************")
        console.log(verificaStatoGiorno)
        console.log(verificaStatoGiorno.data)
        console.log(verificaStatoGiorno.data.length)
        console.log("###########")

        if (verificaStatoGiorno.data == null || 
          verificaStatoGiorno.data.length == 0 || 
          verificaStatoGiorno.data.length == null) {

          //console.log("Create NEW RECORD");
          var parameters = {};
          parameters.webServiceName = "CreateFeriePermessi";
          parameters.data = data;
          parameters.datadef = datadef;

          parameters.urlMethod = "/idempiere/callWebService";
          parameters.debug = true;

          that.$store.dispatch("postAxiosAction", parameters).then(
            response => {
              console.log(response);
            },
            error => {
              console.error("Niente dal server riprovo nuovamente");
            }
          );
        } else {
          console.log("update RECORD");
          var fct_holiday_id = verificaStatoGiorno.data[0].fct_holiday_id;

          data.fct_holiday_ID = fct_holiday_id;
          datadef.fct_holiday_ID = "n";

          var parameters = {};
          parameters.webServiceName = "CreateTimesheetwh";
          parameters.data = data;
          parameters.datadef = datadef;

          parameters.urlMethod = "webservices/rest/v1/vitech/updateFerieMalattie";
          parameters.debug = true;

          that.$store.dispatch("postAxiosAction", parameters).then(
            response => {
              console.log(response);
            },
            error => {
              console.error("Niente dal server riprovo nuovamente");
            }
          );
        }
      })

    
    },
    salvaEventoSuServer(eventoOre, dataStrUni) {
      var that = this;
      //metodo che salva l'evento sul sistema su una tabella temporanea
      //fa un insert o un update su una tabella di sistema
      //fa l'update se l'evento esisteva già
      /*
      /idempiere/callWebService
      */

      if (eventoOre.totaleOre() == 0) {
        alert("Totale ore 0, non salvato");
        return;
      }

      console.log(dataStrUni);
      console.log(eventoOre.tipoPernotto);

      var data = {};
      data.AD_User_ID = this.$session.get("ad_user_id");
      data.C_Project_ID = eventoOre.c_project_id;
      data.oreinterne = eventoOre.oreInterne;
      data.oreesterneassistenza = eventoOre.oreEsterneAssistenza;
      data.oreesternemontaggio = eventoOre.oreEsterneMontaggio;
      data.oreviaggio = eventoOre.oreViaggio;
      data.pernotto = eventoOre.pernotto == "Y" ? "Y" : "N";
      data.TipoPernotto = eventoOre.tipoPernotto;
      data.FoglioDiLavoro = eventoOre.fogliodilavoro
        ? eventoOre.fogliodilavoro
        : "";
      data.timesheetdate = dataStrUni + " 00:00:00";

      console.log(data.oreviaggio);

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.C_Project_ID = "i";
      datadef.oreinterne = "n";
      datadef.oreesterneassistenza = "n";
      datadef.oreesternemontaggio = "n";
      datadef.oreviaggio = "n";
      datadef.pernotto = "s";
      datadef.TipoPernotto = "s";
      datadef.FoglioDiLavoro = "s";
      datadef.timesheetdate = "s";

      var fct_timesheetwh_id = eventoOre.fct_timesheetwh_id;

      if (fct_timesheetwh_id == null) {
        console.log("Create NEW RECORD");
        //carica dettaglio item attivo
        datadef.fct_timesheetwh_ID = "i";
        data.fct_timesheetwh_ID = -1;

        var parameters = {};
        parameters.webServiceName = "CreateTimesheetwh";
        parameters.data = data;
        parameters.datadef = datadef;

        parameters.urlMethod = "/idempiere/callWebService";
        parameters.debug = true;

        //console.log(parameters);

        this.$store.dispatch("postAxiosAction", parameters).then(
          response => {
            console.log(response);
            //this.getListaListaOreServer();
            //this.listaProgetti = response;
            //this.getAttachmentList();
            eventoOre.fct_timesheetwh_id = response[0].recordID;
            console.log(eventoOre.fct_timesheetwh_id);

            /*
            this.dataOre.forEach(function(item, index) {
              */

            that.dataOre.forEach(function(item, index) {
              if (
                item.c_project_id == eventoOre.c_project_id &&
                item.data === dataStrUni
              ) {
                console.log("TROVATO !!!!");
                console.log(item.ore);
                //valoreRitorno = item.ore;
                // && item.data == dataStrUni) {
                //console.log(eventoOre.totaleOre());
                //eventoOre.fct_timesheetwh_id = response.recordID;
                //eventoOre.fogliodilavoro = "pippoooo";
                item.ore = eventoOre.totaleOre();
                item.eventoOre = eventoOre;

                //trovatoSuOreGiorno = true;
              }
            });
            /*
            for (var i in that.dataOre) {
              console.log(that.dataOre[i]);
              if (
                that.dataOre[i].c_project_id == eventoOre.c_project_id &&
                that.dataOre[i].data == dataStrUni
              ) {
                console.log("###########################################");
                console.log(that.dataOre[i].fogliodilavoro)
                console.log("###########################################");
                that.dataOre[i].fogliodilavoro = "pippoooo";
                that.dataOre[i].fct_timesheetwh_ID = response.recordID;
                console.log(that.dataOre[i].fogliodilavoro)
              }
            }
              */
            /*});*/
          },
          error => {
            console.error("Niente dal server riprovo nuovamente");
          }
        );
      } else {
        console.log("UPDATE informazioni");
        //metodo custom di update

        datadef.fct_timesheetwh_ID = "i";
        data.fct_timesheetwh_ID = eventoOre.fct_timesheetwh_id;

        var parameters = {};
        parameters.webServiceName = "CreateTimesheetwh";
        parameters.data = data;
        parameters.datadef = datadef;

        parameters.urlMethod = "webservices/rest/v1/vitech/updateTimesheetwh";
        parameters.debug = true;

        //console.log(parameters);

        this.$store.dispatch("postAxiosAction", parameters).then(
          response => {
            console.log(response);

            this.listaProgetti = response;
            this.getAttachmentList();
            this.getListaListaOreServer();
          },
          error => {
            console.error("Niente dal server riprovo nuovamente");
          }
        );
      }
    },
    cancellaRegistrazioneOreServer() {
      var data = {};
      data.fct_timesheetwh_id = this.dialogFct_timesheetwh_ID;

      var datadef = {};
      datadef.fct_timesheetwh_id = "i";
      var parameters = {};

      parameters.data = data;
      parameters.datadef = datadef;

      parameters.urlMethod = "webservices/rest/v1/vitech/deleteTimesheetwh";
      parameters.debug = true;

      //console.log(parameters);

      this.$store.dispatch("postAxiosAction", parameters).then(
        response => {
          this.getListaListaOreServer();
        },
        error => {
          console.error("Niente dal server riprovo nuovamente");
        }
      );
    },
    async getListaListaOreServer() {

      this.getListaCommesseServer();
      this.getListaProgetti();
      this.dataOre = [];
      var that = this;

      console.log(
        "dataRifSettimanaSelezionata" + this.dataRifSettimanaSelezionata
      );

      var d = new Date(this.dataRifSettimanaSelezionata);
 
      var dayFrom = d.getDate() - 12;
      var dataColonnaFrom = new Date(d.setDate(dayFrom));
      var dataStrUniFrom = this.getDataStrUNI(dataColonnaFrom);

      var dayTo = d.getDate() + 24;
      var dataColonnaTo = new Date(d.setDate(dayTo));
      var dataStrUniTo = this.getDataStrUNI(dataColonnaTo);


      var parameters = {};
      var data = {};
      data.dateFrom = dataStrUniFrom
      data.dateTo = dataStrUniTo

      parameters.idempiereRestPath = "vitech/getListaListaOreServer";
      parameters.data = data;
      parameters.debug = true;

      var verificaStatoGiorno

      await this.$store.dispatch("callIdempiereRest", parameters).then(response => {

        var listaEventi = response.data

        console.log(listaEventi)

        listaEventi.forEach(function(item, index) {
          //console.log(item);

          var newitem = {};

          var eO = new EventoOre(
            item.c_project_id,
            item.oreinterne,
            item.oreesternemontaggio,
            item.oreesterneassistenza,
            item.oreviaggio,
            item.pernotto,
            item.tipopernotto,
            item.fogliodilavoro,
            item.fct_timesheetwh_id
          );

          newitem.c_project_id = item.c_project_id;

          that.listaProgetti.forEach(function(item1, index1) {
            if (item.c_project_id == item1.c_project_id) {
              newitem.name = item1.selectdesc;
            }
          });

          newitem.ore = eO.totaleOre();

          newitem.data =
            item.tsdyear +
            "-" +
            ("0" + item.tsdmonth).slice(-2) +
            "-" +
            ("0" + item.tsdday).slice(-2); //
          newitem.eventoOre = eO;

          that.dataOre.push(newitem);
        });

        this.getListaProgetti();
      })
    },
    getListaBPartnerServer() {


      console.log("getListaBPartnerServer");

      //carica dettaglio item attivo
      var parameters = {};

      parameters.debug = false;

      parameters.urlMethod = "webservices/rest/v1/vitech/getListaBPartnerServer";
      parameters.debug = true;

      this.$store.dispatch("callGenericPostMethod", parameters).then(
        response => {
          this.listaBPartner = response.data;
        },
        error => {
          console.error("Niente dal server riprovo nuovamente");
        }
      );
    },
    //
    // Get lista ferie/malattie
    getListaFerieMalattie() {
      var that = this;
      console.log("[m]getListaFerieMalattie");

      var datadef = {};
      datadef.AD_User_ID = "i";
      datadef.day = "s";
      datadef.Type = "s";

      //carica dettaglio item attivo
      var parameters = {};
      parameters.urlMethod = "webservices/rest/v1/vitech/getHoliday";
      parameters.debug = true;

      this.$store.dispatch("callGenericPostMethod", parameters).then(
        response => {
          console.log(response.data)
        if (response.data && response.data.length > 0) {
        response.data.forEach(function(feriemalattie) {

          that.listaPermessi.push({
            key: feriemalattie.day.substring(0, 10),
            value: feriemalattie.Type
          });
        });
        }
      });
    },
    getListaProdottiServer() {
      return new Promise(resolve => {
        this.tabactive = 1;

      var parameters = {};
      parameters.urlMethod = "webservices/rest/v1/vitech/getListaProdottiServer";
      parameters.debug = true;

      this.$store.dispatch("callGenericPostMethod", parameters).then(
          response => {
            //console.log(response);
            this.listaProdotti = response.data;
            //this.getListaListaOreServer();
            //this.getAttachmentList();
            resolve();
          },
          error => {
            console.error("Niente dal server riprovo nuovamente");
            resolve();
          }
        );
      });
    },
    getListaCommesseSelezionabiliServer() {

      return new Promise((resolve) => {
        var parameters = {};
        parameters.idempiereRestPath =  "vitech/getListaCommesseSelezionabiliServer";
        parameters.debug = false;

        this.$store.dispatch("callIdempiereRest", parameters).then(
          (response) => {
            this.commesseAttive = response.data;
            //this.getListaListaOreServer();
            //this.getAttachmentList();
            resolve();
          },
          (error) => {
            console.error("Niente dal server riprovo nuovamente");
            resolve();
          }
        );
      });
    
    },
    getListaCommesseServer() {
      return new Promise(resolve => {
        this.tabactive = 1;

        var parameters = {};
        parameters.urlMethod = Conf.idempiereUrl + "webservices/rest/v1/vitech/getListaCommesseServer";
        parameters.debug = true;

        this.$store.dispatch("callGenericPostMethod", parameters).then(
            response => {
              //console.log(response);
              this.listaProgetti = response.data;
              //this.getListaListaOreServer();
              //this.getAttachmentList();
              resolve();
            },
            error => {
              console.error("Niente dal server riprovo nuovamente");
              resolve();
            }
          );
        });
    },
    async refreshDataMounted() {
      await this.getListaFerieMalattie();

      await this.getListaCommesseServer();
      if (this.listaProgetti.length > 0) {
        console.log("--- 3");
      } else {
        //reject(motivo);
      }

      console.log("--- 4");
      await this.getListaListaOreServer();
      await this.getListaBPartnerServer();

      await this.getListaProdottiServer();
      await this.getListaCommesseSelezionabiliServer();
      this.getListaProgetti();
    },
    apriSchedaMese: function() {
      let mese = this.dateFrom.getMonth();
      let anno = this.dateFrom.getFullYear();
      let parameters = {};
      parameters.mese = mese;
      parameters.anno = anno;

      this.$store.dispatch("schedaMese", parameters).then(response => {
        var datiMese = response.data.mese;

        let ultimoGiorno = new Date(anno, mese + 1, 0).getDate();
        let tipoPernotto = {};
        this.schedaMese = [];
        for (let index in this.listaTipoPernotto) {
          tipoPernotto[
            this.listaTipoPernotto[index].value
          ] = this.listaTipoPernotto[index].name;
        }
        for (let giorno = 1; giorno <= ultimoGiorno; giorno++) {
          this.schedaMese.push({
            num: giorno,
            giorno: this.giorniSettimana[new Date(anno, mese, giorno).getDay()],
            interne: datiMese[giorno]["interne"],
            esterne: datiMese[giorno]["esterne"],
            viaggio: datiMese[giorno]["viaggio"],
            pernotto: tipoPernotto[datiMese[giorno]["pernotto"]]
          });
        }
        this.dialogSchedaMese = true;
      });
    }
  },
  computed: {
    statoGiorno: {
      get() {
        console.log("stato get");
        return "L";
      },
      set(newVal) {
        console.log("stato set" + newVal);
      }
    },
    isNuovaCommessaDisabled: function() {
      //console.log(this.dialogCommDescrizione);
      if (
        this.dialogCommDescrizione &&
        this.dialogCommDescrizione.length > 0 &&
        this.dialogCommCBPartnerID > 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    isAggiuntaCommessaDisabled: function() {
      if (this.progettoSelez) {
        return false;
      } else {
        return true;
      }
    },
    isSalvataggioDisabilitato: function() {
      //console.log("[m]getCurrentState")

      var salvataggioDisabilitato = false;

      return salvataggioDisabilitato; //this.$store.state.adp.headersListaPREZZICAPI
    },
    settimanaSelezionata: function() {
      return this.getSettimanaCorrente(this.dataRifSettimanaSelezionata);
      //var date = new Date();
    },
    dateFrom: function() {
      var d = new Date(this.dataRifSettimanaSelezionata);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    dateTo: function() {
      var d = new Date(this.dataRifSettimanaSelezionata);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) + 7; // adjust when day is sunday
      return new Date(d.setDate(diff));
    },
    headersProgetti: function() {
      //Genera l'header dinamicamente al cambio della settimana
      //primo giorno
      var headersProgetti = [];

      var giorno = {};
      (giorno.text = "COMMESSE"),
        (giorno.align = "left"),
        (giorno.sortable = false),
        (giorno.value = "name");

      var days = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

      for (var i = 0; i < 7; i++) {
        //giorno
        var d = new Date(this.dataRifSettimanaSelezionata);

        var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6 : 1) + i;

        var dataColonna = new Date(d.setDate(diff));

        var giorno = {};
        (giorno.text = days[d.getDay()] + " " + this.getDataStr(dataColonna)),
          (giorno.align = "left"),
          (giorno.sortable = false),
          (giorno.keyData = this.getDataStrUNI(dataColonna)),
          (giorno.value = "name");

        if (this.getDataStr(dataColonna) == this.getDataStr(new Date())) {
          /*giorno.text = "*" + giorno.text + "*";*/
          giorno.class = "today";
        }

        if (d.getDay() == 0 || d.getDay() == 6) {
          /*giorno.text = "*" + giorno.text + "*";*/
          giorno.class = "holiday";
        }

        headersProgetti.push(giorno);
      }

      return headersProgetti;

    },
    currentDate: function() {
      let giorno = new Date().getDate();
      let mese = new Date().getMonth();
      let anno = new Date().getFullYear();
      return new Date(anno, mese, giorno);
    }
  },
  created() {
    this.$store.dispatch("checkSession");
    console.log("created");
  },
  mounted() {
    var ad_user_id = this.$session.get("ad_user_id");
    console.log(ad_user_id);
    /*if (!ad_user_id) {
      router.push({
        name: "Login"
      });
    }*/
    console.log("mounted");
    console.log("--- 1");
    this.dataRifSettimanaSelezionata = new Date();
    this.dataRifS = new Date();

    //this.getListaCommesseServer();
    //setTimeout(() => {

    var that = this;

    this.refreshDataMounted();
    /*
    that.getListaCommesseServer();
    if (that.listaProgetti.length > 0) {
      console.log("--- 3");
    } else {
      //reject(motivo);
    }

    console.log("--- 4");
    this.getListaListaOreServer();

    this.getListaBPartnerServer();
    this.getListaProgetti();
    //}, 300);
    console.log("--- 20000");*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
/*
.progettitable {
  background-color: lightgoldenrodyellow;
  border-bottom: none;
}
*/
.progettitable table.v-table thead th {
  /* background-color: lightblue;
  border-bottom: none;
  font-size: 18px;*/
}

.today {
  background-color: lightgreen;
  font-size: 24px;
  font-weight: bold;
}

.holiday {
  background-color: lightgrey;
  font-size: 24px;
  font-weight: bold;
}

.permessoclass {
  background-color: lightpink;
}

.ferieclass {
  background-color: red;
}

.malattiaclass {
  background-color: red;
}
</style>
